import type { ConfigRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type GetNodeEventRouteParamsRequest = {
  config?: { skipAuth?: boolean };
} & ConfigRouteParamsRequest<never, paths['/events/{id}']['get']['parameters']['path']>;

type NodeEventDataObject = paths['/events/{id}']['get']['responses']['200']['content']['application/json'];

export async function getNodeEvent({ config, routeParams: { id } }: GetNodeEventRouteParamsRequest) {
  return nodeApiClient.get<NodeEventDataObject, ApiClientResponse<NodeEventDataObject>>(
    nodeApiRoutes.events.detail(id),
    config,
  );
}
